import { useCappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck } from '@zg-rentals/ts-capps-client-react-query';
import { useGetListingAlias } from '../routes';

export function useGetLandlordPermissions() {
  const listingAlias = useGetListingAlias();
  const { data, isLoading } = useCappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck(
    { listingAlias },
    { enabled: !!listingAlias },
  );

  return {
    isMissingPermissions: !isLoading && data?.hasPermission === false,
    permissionDeniedReason: data?.reason,
    listingAlias,
  };
}
